import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    language: string;
    switchingLanguage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Language menu item label */
            language: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LanguageSelectionMenuItem.language?c=5shkyqufgfm6", defaultMessage: "Language" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the spinner shown while a language switch is in progress */
            switchingLanguage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LanguageSelectionMenuItem.switchingLanguage?c=37df25hx22iw5", defaultMessage: "Switching language" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
